<script setup>

import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import InteractionFormService from '@/services/InteractionFormService';
import {formatDate, showErrorMessage, showSuccessMessage} from '@/helper';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import OnboardingOptionsModal from '@/components/modals/OnboardingOptionsModal.vue';
import interactionFormService from '@/services/InteractionFormService';

const props = defineProps({
  entityId: {
    type: Number,
    default: null,
  },
});

const {t} = useI18n();


const rows = ref([]);

const isLoading = ref(false);

const showCreateButton = ref(false);

const columns = ref([
  {
    label: t('InteractionFormsTableComponent.created_at'),
    field: 'created_at',
    sortable: false,
    formatFn: (value) => formatDate(value, 'd.m.Y H:i')
  },
  {
    label: t('InteractionFormsTableComponent.state'),
    field: 'state',
    sortable: false,
    formatFn: (value) => t('InteractionFormsTableComponent.state_' + value)
  },
  {
    label: '',
    field: 'action',
    sortable: false,
  },
]);

defineExpose({
  showCreateButton
})

onMounted(async () => {
      getOnboardings();
      emitter.on('onboardingSaved', () => {
        getOnboardings();
      });
    }
);

function getOnboardings() {
  isLoading.value = true;
  InteractionFormService.getAllByClient(props.entityId)
      .then((response) => {
        rows.value = response;
        isLoading.value = false;
        showCreateButton.value = !response.some(form => form.state !== 'COMPLETED');
      })
      .catch((error) => {
        console.log(error);
      });
}

function changeState(row) {
  interactionFormService.changeState(row.id, 'WAITING_FOR_CLIENT')
      .then(() => {
        row.state = 'WAITING_FOR_CLIENT';
      });
}

function continueOnboarding(row) {
  interactionFormService.continueOnboarding(row.id)
      .then((response) => {
        if (response.message) {
          showErrorMessage(response.message);
        } else {
          emitter.emit('startAssistedOnboarding', response);
        }
      });
}

function deleteOnboarding(row) {
  interactionFormService.delete(row.id)
      .then(() => {
        const index = rows.value.findIndex(r => r.id === row.id);
        rows.value.splice(index, 1);
        showCreateButton.value = !rows.value.some(form => form.state !== 'COMPLETED');
      })
}
</script>

<template>
  <div>
    <div class="table-container">
      <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
                  enabled: true,
                rowsPerPageLabel: t('InteractionFormsTableComponent.entriesPerPage'),
                nextLabel: t('InteractionFormsTableComponent.next'),
                prevLabel: t('InteractionFormsTableComponent.previous'),
                ofLabel: 'z',
                }">
        <template #table-row="props">
          <span v-if="props.column.field == 'action'">
            <span style="font-weight: bold; float: right">
              <button v-if="props.row.state !== 'COMPLETED'" type="button" class="btn btn-danger btn-normal me-2" @click="deleteOnboarding(props.row)"><span>{{ t('InteractionFormsTableComponent.delete') }}</span></button>
              <button v-if="props.row.state === 'CONCEPT'" type="button" class="btn btn-primary btn-normal me-2" @click="continueOnboarding(props.row)"><span>{{ t('InteractionFormsTableComponent.continue') }}</span></button>
              <button v-if="props.row.state === 'CONCEPT'" type="button" class="btn btn-primary btn-normal" @click="changeState(props.row)"><span>{{ t('InteractionFormsTableComponent.send_to_client') }}</span></button>
            </span>
          </span>
        </template>
        <template v-slot:emptystate v-if="!isLoading">
          <div class="text-center">
            {{ t('InteractionFormsTableComponent.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="isLoading">
          <div class="text-center">
            {{ t('InteractionFormsTableComponent.loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
